module.exports = __webpack_public_path__ + "amcharts/images/dragIconRoundBigBlackH.svg";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRoundBigBlackH.svg
// module id = 251
// module chunks = 0